const fileOptions = {
	display: 'flex',
	flexFlow: 'row',
};

const fileOption = {
	padding: '0 1rem 0.5rem 0',
};

const acceptedFormats = {
	display: 'inline',
	paddingLeft: '1rem',
};

const fileDescription = {
	paddingTop: '0.5rem',
	lineHeight: 1.15
};

const fileUploadSelector = {
	padding: '1rem 0',
};

const fileInput = {
	display: 'none',
};

const fileFieldList = {
	listStyleType: 'decimal',
	margin: 0,
};

const fileUploadButton = {
	display: 'inline-block',
	fontWeight: 500,
	textTransform: 'unset',
	marginLeft: '-40px',
	paddingTop: '7px',
};

const fileUploadButtonIcon = {
	paddingRight: '0.5rem',
};

const fileNameInput = {
	// using pixels here since the legacy survey uses pixels
	maxWidth: '200px',
	display: 'inline',
	marginRight: '0.5rem'
};

const displayWithFile = (hasFile) => {
	let style = {
		display: 'block',
	};
	if (hasFile) {
		style = {
			display: 'none',
		};
	}
	return style;
};

export {
	fileOptions,
	fileOption,
	acceptedFormats,
	fileDescription,
	fileUploadSelector,
	fileInput,
	fileFieldList,
	fileUploadButton,
	fileUploadButtonIcon,
	fileNameInput,
	displayWithFile,
};
